import { render, staticRenderFns } from "./StatisticVer.vue?vue&type=template&id=e2e5644a&"
import script from "./StatisticVer.vue?vue&type=script&lang=js&"
export * from "./StatisticVer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports